import {faMagnifyingGlass} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';
import Flag from '@/components/common-components/components/flag';
import {useStore} from '@/store/root-store';
import {NextImg} from '@/utils/nextImg';
import {openLiveChat} from '@/utils/intercom';

interface Props {
  text?: string;
  // btnText?: string;
  imgText?: string;
  icon?: boolean;
  description?: string;
  search?: boolean;
  keywordCompetition?: boolean;
  isHeader?: boolean;
  isFlag?: boolean;
  headDescription?: string;
  countryCode?: string;
  isMiniTable?: boolean;
  }

export const EmptyStateKeDetail:React.FC<Props> = observer(({text, icon=false, imgText, description, countryCode, search, keywordCompetition=false, isHeader, isFlag, headDescription, isMiniTable}) => {
  const {settings: {customer: {isGHLAccount, profile: {isWhitelabel}}}} = useStore('');
  return (
    <div style={{display: 'flex', justifyContent: icon || isMiniTable ? 'center' : ''}}>
      {
        isHeader ?

          <ContainerHeader isHeader={isHeader }>
            <div style={{display: 'flex'}}>
              {isFlag&& <Flag width={18} code={countryCode ?? 'us'} style={{marginRight: '10px'}}/>}
              <NAWrapper>N/A</NAWrapper>
            </div>
            <HeadingDescription>{headDescription ? headDescription : ''}</HeadingDescription>
          </ContainerHeader> :
          <Container isMiniTable ={isMiniTable} icon={icon} keywordCompetition={keywordCompetition}>
            {icon ? <NextImg src={imgText ? imgText : '/icons/empty-z-line.svg'}/> : search ? <FontAwesomeIcon icon={faMagnifyingGlass} color='#A3A4A4' style={{float: 'left'}}/> : ''}
            <Text>{text ? text : ''}</Text>
            {!isWhitelabel && description ? <DescriptionsWrapper style={{marginTop: text ? '': '20px'}}>{description }</DescriptionsWrapper>:
              isGHLAccount ? '' : <> <DescriptionsWrapper><a onClick={()=> openLiveChat()}>Chat with a team member</a> to learn why.</DescriptionsWrapper></>
            }
          </Container>}
    </div> );
});

const Container = styled.div<{ isMiniTable?: boolean; icon?: boolean; keywordCompetition?: boolean}>`

  justify-content: center;
  margin: ${p => p.icon ? '60px' : p?.keywordCompetition ?'10px 10px 10px 0px' :p?.isMiniTable ? '120px 60px 60px 0px' : '80px 60px 60px 0px'};

  img {
    width: 40px;
    height: 40px;
  }
`;
const NAWrapper = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #4E5156;
`;
const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #121212;
  margin-top: 16px;
`;

const DescriptionsWrapper = styled.div`
 font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #4E5156;
`;
const ContainerHeader = styled.div<{icon?: boolean; keywordCompetition?: boolean; isHeader?: boolean}>`
  justify-content: center;
  margin: ${p => p.icon ? '60px' : p?.keywordCompetition ?'10px 10px 10px 0px' : p?.isHeader ? '20px 20px 20px 0px' :'80px 60px 60px 0px'};
`;
const HeadingDescription = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #A3A4A4;
`;

